import { useIntl } from "gatsby-plugin-intl"

import paths from "utils/paths"

const useNavigationContent = () => {
  const { formatMessage } = useIntl()

  const {
    about,
    aboutWhatWeDo,
    aboutSurveyOurProcess,
    aboutSeeOurImpact,
    portfolio,
  } = paths

  return [
    {
      label: formatMessage({ id: "navbar.about.label" }),
      path: about,
      subMenuContent: [
        {
          path: about,
          label: formatMessage({
            id: "navbar.about.introduction.label",
          }),
          icon: "introduction",
          text: formatMessage({
            id: "navbar.about.introduction.text",
          }),
        },
        {
          path: aboutWhatWeDo,
          label: formatMessage({
            id: "navbar.about.whatWeDo.label",
          }),
          icon: "business",
          text: formatMessage({
            id: "navbar.about.whatWeDo.text",
          }),
        },
        {
          path: aboutSeeOurImpact,
          label: formatMessage({
            id: "navbar.about.ourImpact.label",
          }),
          icon: "impact",
          text: formatMessage({
            id: "navbar.about.ourImpact.text",
          }),
        },
        {
          path: aboutSurveyOurProcess,
          label: formatMessage({
            id: "navbar.about.surveyOurProcess.label",
          }),
          icon: "survey",
          text: formatMessage({
            id: "navbar.about.surveyOurProcess.text",
          }),
        },
      ],
    },
    {
      label: formatMessage({ id: "navbar.portfolio" }),
      path: portfolio,
    },
  ]
}

export default useNavigationContent
